import type { AppointmentConfigJsonType } from '@bb/domain/dist/types';
import Axios from 'axios';

type ExternalAppointmentConfigType = Pick<
  AppointmentConfigJsonType,
  | 'noMoreShowings'
  | 'maxDuration'
  | 'isVirtualTourEnabled'
  | 'autoConfirm'
  | 'advAutoConfEnabled'
  | 'days'
  | 'specialTimes'
  | 'preBookingInformation'
> & {
  isVirtualTourEnabled?: boolean;
};

const getExternalAppointmentConfig = async (listingId: string) => {
  const { data } = await Axios.get<ExternalAppointmentConfigType>(
    `listing/${listingId}/appointments/external_config`,
  );
  return data;
};

export default getExternalAppointmentConfig;
